import _ from 'lodash';

let nextID = 0;

const aNavStep = {
    displayName: undefined,
    isInProgress: false,
    isCompleted: false
};

function NavigationStep(data, translator) {
    if (data) {
        if (translator) {
            // This line is only for display keys defined in a JSON file
            data.displayName = translator(data.displayKey);
        }

        const formattedData = Object.assign({}, aNavStep, data);

        _.extend(this, formattedData);

        this.id = nextID;
        nextID++;
    }
}

export default NavigationStep;